import moment from 'moment';

import { DataListValue } from '~/components/Formik/InputSearch/DataListInput';
import { SelectListValue } from '~/components/Formik/InputSearch/SelectListInput';
import { parseArrayIntoString } from '~/pages/utils/parseArrayIntoString';

import { FieldVariableType, ProcessFormField } from '../parser/types';
import { METADATA_SEPARATOR, ProcessSubmitVariable } from './types';

export function createCamundaVariable(
  field: ProcessFormField,
  value?: unknown,
): ProcessSubmitVariable {
  const {
    type,
    validations: { dataListName, slList, execList },
  } = field;

  if (dataListName) {
    return createCamundaDataListVariable(value as Array<DataListValue>);
  }

  if (slList || execList) {
    return createCamundaSelectListVariable(value as Array<SelectListValue>);
  }

  if (type === FieldVariableType.DATE) {
    return createCamundaDateVariable(value as string);
  }

  if (type === FieldVariableType.ENUM) {
    return createCamundaEnumVariable(value as { value: string });
  }

  if (type === FieldVariableType.BOOLEAN) {
    return createCamundaBooleanVariable(value as boolean);
  }

  return {
    value: value as string,
    type: 'String',
  };
}

function createCamundaDateVariable(value?: string): ProcessSubmitVariable {
  return {
    value: value
      ? moment(value, 'DD/MM/YYYY', true).format('YYYY-MM-DDTHH:mm:ss.SSS-0300')
      : null,
    type: 'Date',
  };
}

function createCamundaEnumVariable(option?: {
  value: string;
}): ProcessSubmitVariable {
  return {
    value: option?.value ?? null,
    type: 'String',
  };
}

function createCamundaBooleanVariable(value: boolean): ProcessSubmitVariable {
  return {
    value,
    type: 'Boolean',
  };
}

function createCamundaDataListVariable(
  value?: Array<DataListValue>,
): ProcessSubmitVariable {
  const parsedValue = parseArrayIntoString<DataListValue>(
    value ?? [],
    'value',
    METADATA_SEPARATOR,
  );

  return {
    value: parsedValue,
    type: 'String',
  };
}

function createCamundaSelectListVariable(
  value?: Array<SelectListValue>,
): ProcessSubmitVariable {
  const parsedValue = parseArrayIntoString<SelectListValue>(
    value ?? [],
    'id',
    METADATA_SEPARATOR,
  );

  return {
    value: parsedValue,
    type: 'String',
  };
}
